/**
 * SkipLandmark applier.
 *
 * Advances phase from unlockLandmark → endTurn. No other state changes.
 *
 * Spec §9.2.
 */

import type { SkipLandmarkAction } from "../types/actions";
import type { GameState } from "../types/game-state";
import { bumpVersion } from "./common-applier";

export const applySkipLandmark = (
  state: GameState,
  _action: SkipLandmarkAction,
): GameState => ({
  ...state,
  ...bumpVersion(state),
  turn: {
    ...state.turn,
    phase: "endTurn",
  },
});
